export default __webpack_public_path__ + "static/media/recommended_icon.3f3c5f6b.svg";